export const TRAILER_HOME = {
  nickname: 'PRODUCTS.TRAILER_HOME.nickname',
  properties: [
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO' },
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR_MODEL', group: 'OBJECT_INFO'},
  ],
  icon:'trailer-home'
};
